import OtherIcon from '../../assets/logo/Other.svg'

const OtherHomeCustomIcon = () => (
  <img src={OtherIcon} alt='logo' />
);

export default OtherHomeCustomIcon;